import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from '@angular/core';
import { ThirdPartyEvaluationFormItemAnswer } from '../../../models/thirdparty-evaluation-form-item-answer';
import {FormGroup, FormControl, AbstractControl, Validators} from '@angular/forms';
import { ThirdPartyEvaluationFormItem } from '../../../models/thirdparty-evaluation-form-item';
import { BehaviorSubject, Observable } from 'rxjs';
import { GenericConversationCnstrc, ThirdPartyConversationItem } from '../../../models/thirdparty-conversation-item';
import { ThirdpartyConversationService } from '../../../services/thirdparty-conversation.service';
import { ThirdPartyFormConversations } from '../../../models/thirdparty-form-conversations';
import { ThirdPartyEvaluationFormAnswerFile } from '../../../models/thirdparty-evaluation-form-answer-file';
import { AuthService } from '../../../core/auth/_services/auth.service';
import { PermissionType } from '../../../core/auth/enums/permission.enum';
import { EvaluationFormItemType } from '../../../models/due-diligence/evaluation-form-item-type.table';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { MatChipInputEvent } from '@angular/material/chips';
import { formsCompletedAnswer } from '../../../models/thirdparty-evaluation-status';
import { ThirdPartyFollowUpTaskFormItemAnswer } from '../../../models/thirdparty-tracing-tasks/thirdparty-tracing-task-external';
import { ThirdpartyTaskConversation } from '../../../models/thirdparty-tracing-tasks/conversations';
import { ThirdPartyEvaluationFormItemFile } from '@app/models/thirdparty-evaluation-form-item-file';
import { RecordTypeQuestionComponent } from '../record-type-question/record-type-question.component';

@Component({
  selector: 'kt-evaluation-form-item',
  templateUrl: './evaluation-form-item.component.html',
  styleUrls: ['./evaluation-form-item.component.scss']
})
export class EvaluationFormItemComponent implements OnInit {

  currentItemType = EvaluationFormItemType;

  private _evaluationFormItem: BehaviorSubject<ThirdPartyEvaluationFormItem>;

  @Input() set evaluationFormItem(value) {
    this._evaluationFormItem.next(value);
  }
  get evaluationFormItem() {
    return this._evaluationFormItem.getValue();
  }

  @Input()
  conversationContextId: number;

  _formAnswers$: BehaviorSubject<formsCompletedAnswer[] | ThirdPartyFollowUpTaskFormItemAnswer[] | any[]>;
  @Input() set formAnswers(value) {
    this._formAnswers$.next(value);
  }
  get formAnswers() {
    return this._formAnswers$.getValue();
  }

  itemType: EvaluationFormItemType;
  label: string;
  explanation: string;
  @Input()
  answers: ThirdPartyEvaluationFormItemAnswer[];
  @Input()
  evaluationFormControlName: string;
  commentAvailable: boolean;
  itemFilesAvailable: boolean;
  formItemId: number;

  _itemAnswerId$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  set itemAnswerId$(value: number) {
    this._itemAnswerId$.next(value);
  }
  get itemAnswerId$(): number {
    return this._itemAnswerId$.getValue();
  }

  @Input() evaluationContextId: number = 0;
  @Input() evaluationFormGroup: FormGroup;
  @Input() maxLength: number = 200;
  @Input() maxCommentLength: number = 200;
  @Input() minCommentLength: number = 10;
  @Input() exploreMode: boolean = false;
  // Conversation feature
  @Input() showConversation: boolean = false;
  // Force Inite Conversation feature
  @Input() forceShowConversation: boolean = false;
	@Input() conversationItemClass: GenericConversationCnstrc;
  // FileUpload feature
  @Input() enableFileManager: boolean = false;
  // Disable Features functions, read-only mode.
  @Input() protectedMode: boolean = false;

  _formConversations$: BehaviorSubject<ThirdPartyFormConversations | ThirdpartyTaskConversation>;
  @Input() set formConversations(value) {
    this._formConversations$.next(value);
  };
  get formConversations() {
    return this._formConversations$.getValue();
  };

  _evaluationFormFiles$: BehaviorSubject<any[]>;
  @Input() set evaluationFiles(value) {
    this._evaluationFormFiles$.next(value);
  };
  get evaluationFiles() {
    return this._evaluationFormFiles$.getValue();
  };
  @Input()
  disabledButtons: Function;
  @Input()
  fileDownloadFnc: Function;
  @Input()
  initialFiles: ThirdPartyEvaluationFormItemFile[];
  @Input()
  disableConversation: boolean = false;

  conversation$: BehaviorSubject<ThirdPartyConversationItem[]>;
  @Output() message: EventEmitter<ThirdPartyConversationItem> = new EventEmitter();
  @Output() messageDequeue: EventEmitter<ThirdPartyConversationItem> = new EventEmitter();
  @Output() fileUpload: EventEmitter<ThirdPartyEvaluationFormAnswerFile> = new EventEmitter();
  @Output() fileDequeue: EventEmitter<ThirdPartyEvaluationFormAnswerFile> = new EventEmitter();

  currentUser: any;
  requiredComments = false;
  lastAnswerId: number = 0;
  noSelectionItem: boolean = false;
  currentAnswerId: number = 0;
  lastAnswerIndex = null;

  constructor(
    private _conversationService: ThirdpartyConversationService,
    private _authService: AuthService
  ) {
    this._evaluationFormItem = new BehaviorSubject<ThirdPartyEvaluationFormItem>(new ThirdPartyEvaluationFormItem());
    this.conversation$ = new BehaviorSubject<ThirdPartyConversationItem[]>([]);
    this._formAnswers$ = new BehaviorSubject<any[]>([]);
    this._formConversations$ = new BehaviorSubject<ThirdPartyFormConversations>(new ThirdPartyFormConversations())
    this._evaluationFormFiles$ = new BehaviorSubject<any[]>([]);
  }

  ngOnChanges(){
    console.log(this.formAnswers)
    
    // console.log(this.evaluationFormGroup.disabled)
    this._itemAnswerId$.next(this.formAnswers.find(x => x.itemTypeId == 6)?.id);
    this.currentAnswerId = this.formAnswers.find(x => x.itemTypeId == 6)?.id;
    if(this.formAnswers.length == 1){
      this._itemAnswerId$.next(this.formAnswers[0].id);
      this.currentAnswerId = this.formAnswers[0].id;
    }
  }

  ngOnInit() {
    this.evaluationContextId = this.evaluationContextId || 0;

    this._evaluationFormItem.subscribe(x => {
      this.itemType = this.evaluationFormItem.itemTypeId;// this.currentItemType.List;
      this.label = this.evaluationFormItem.description;
      this.explanation = this.evaluationFormItem.explanation;
      this.answers = this.answers || this.evaluationFormItem.appFormItemAnswers;
      this.evaluationFormControlName = this.evaluationFormControlName || this.evaluationFormItem.code;
      this.commentAvailable = this.evaluationFormItem.isCommentAvailable;
      this.itemFilesAvailable = this.evaluationFormItem.isFileAvailable;

        // console.log(this.evaluationFormItem)
        // console.log(this.evaluationFormItem.appFormItemAnswers)
        

      if(this.currentAnswerId == 0 || !this.currentAnswerId){
        // this.currentAnswerId = this.formAnswers[this.evaluationFormItem.itemOrder-1].id;
        this.formAnswers.forEach(x => {
          // console.log(x)
          if(this.evaluationFormItem.appFormItemAnswers.find(y => y.id == x.appFormItemAnswerId)){
            this.currentAnswerId = x.id;
          }
        })
      }

        setTimeout(()=>{
          // console.log(this._itemAnswerId$.getValue())
          if(this.itemType == EvaluationFormItemType.Text || this.evaluationFormItem.itemTypeId == EvaluationFormItemType.Text){
            if(this._itemAnswerId$.getValue() == 0 || !this._itemAnswerId$.getValue()){
              // console.log(this.evaluationFormItem.appFormItemAnswers[0]?.id)
              this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
            }
          }else if(this.itemType == EvaluationFormItemType.SingleDropDownSelection || this.evaluationFormItem.itemTypeId == EvaluationFormItemType.SingleDropDownSelection){
            if(this._itemAnswerId$.getValue() == 0 || !this._itemAnswerId$.getValue()){
              // this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
              // this.lastAnswerId = this.evaluationFormItem.appFormItemAnswers[0]?.id as number
              if(window.location.href.includes('start')){
                this._itemAnswerId$.next(this.evaluationFormItem.id);
              }else{
                this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
              }
            }
          }else if(this.itemType == EvaluationFormItemType.MultipleDropDownSelection){
            if(this._itemAnswerId$.getValue() == 0 || !this._itemAnswerId$.getValue()){
              this._itemAnswerId$.next(this.evaluationFormItem.id);
            }
          }else if(this.itemType == EvaluationFormItemType.RadioButton){
            // if(this._itemAnswerId$.getValue() == 0 || !this._itemAnswerId$.getValue()){
            //   if(window.location.href.includes('start')){
                this._itemAnswerId$.next(this.evaluationFormItem.id);
            //   }else{
            //     this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
            //   }
            // }else{
            //   this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
            // }
          }else if(this.itemType == EvaluationFormItemType.List){
            this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
            // console.log(this.evaluationFormItem)
            // console.log(this.formAnswers)
          }else if(this._itemAnswerId$.getValue() == 0 || !this._itemAnswerId$.getValue()){
            // this._itemAnswerId$.next(this.evaluationFormItem.id);
            // console.log(this.evaluationFormControlName)
            // console.log(this.evaluationFormItem)
            if(this.evaluationFormGroup.get(this.evaluationFormControlName).value || this.evaluationFormGroup.get(this.evaluationFormControlName).value?.length > 0){
              this._itemAnswerId$.next(this.evaluationFormGroup.get(this.evaluationFormControlName).value);
            }else{
              this._itemAnswerId$.next(this.evaluationFormItem.appFormItemAnswers[0]?.id as number);
            }
          }
        },2000);

        // console.log(this._evaluationFormFiles$.getValue())
        setTimeout(() => {
          if(this.protectedMode || !window.location.href.includes('start')){
            let filesObject = this._evaluationFormFiles$.getValue();
            let filesByAnswer = [];
            this._itemAnswerId$.next(this.evaluationFormItem.id);

            // console.log(this.formAnswers)

            filesObject.forEach(file => {
              this.formAnswers.forEach(fa => {
                if(fa.appFormItemId == this.evaluationFormItem.id){
                  if(file.thirdPartyEvaluationFormItemId == fa.id && !filesByAnswer.find(f => f.id == file.file.id)){
                    // console.log(fa)
                    // console.log(file)
                    filesByAnswer.push(file.file);
                    this._itemAnswerId$.next(file.thirdPartyEvaluationFormItemId);
                  }
                }
              })
            });
            this.initialFiles = filesByAnswer;
            console.log(this.itemType)
            console.log(filesByAnswer)
            console.log(this.initialFiles)
          }
        },2500);

      // Setting Dummy answer for DueDiligenceFeatureItem
      if (this.itemType == EvaluationFormItemType.DueDiligenceFeatureItem) {
        if (this.evaluationFormItem.followUpTaskFormItemAnswers){
          this.evaluationFormGroup.get(this.evaluationFormControlName).patchValue(this.evaluationFormItem.followUpTaskFormItemAnswers[0].id as number);
        } else if (this.evaluationFormItem.appFormItemAnswers){
          this.evaluationFormGroup.get(this.evaluationFormControlName).patchValue(this.evaluationFormItem.appFormItemAnswers[0].id as number);
        }
        
      }
    });

    for (const key in this.evaluationFormGroup.controls) {
      if (this.evaluationFormGroup.controls.hasOwnProperty(key)) {
        const element = this.evaluationFormGroup.controls[key];

        // Mark as dirty if control has value
        if (!this.isEmptyOrWhiteSpace(element.value)) {
          element.markAsDirty();
        }
      }
    }

    // Get Conversation items for the corresponding AnswerId
    this._formAnswers$.subscribe({
      next: answers => {
        this.getChildtItemAnswerId(answers);
        this.fillUpConversation(answers);
      }
    });
    // Uso este subscribe para no depender de quien se ejecute primero
    this._formConversations$.subscribe({
      next: x => this.fillUpConversation(this.formAnswers)
    });

    this.currentUser = this._authService.currentUser;

    this.evaluationFormGroup.get(this.evaluationFormControlName).valueChanges.subscribe(
      data => {
        if (this.evaluationFormItem.isCommentRequierdInAutoevaluateChange && data !== this.evaluationFormItem.defaultAutoevalutedAnswer) {
          this.requiredComments = true;
        } else if(data === this.evaluationFormItem.defaultAutoevalutedAnswer){
          this.requiredComments = false;
        } else {
          this.requiredComments = false;
        }
      }
    )

    if (this.evaluationFormGroup.get(this.evaluationFormControlName + '-comment')) {
      this.evaluationFormGroup.get(this.evaluationFormControlName + '-comment').valueChanges.subscribe(
        data => {
          if (data) {
            if (this.evaluationFormItem.isCommentRequierdInAutoevaluateChange &&
                this.evaluationFormGroup.get(this.evaluationFormControlName).value != this.evaluationFormItem.defaultAutoevalutedAnswer) {
                this.requiredComments = false;
            } 
          }   
        }
      )
    }

  }

  ngAfterViewInit(){
    if(!this.disabledButtons){
      this.evaluationFormGroup.enable();
    }
  }

  getChildtItemAnswerId(answers: any[]) {
    const itemFormAnswer = this.evaluationFormGroup.get(this.evaluationFormControlName).value;

    if (!Array.isArray(itemFormAnswer)) {
      this.itemAnswerId$ = this.findItemAnswerId(answers);
    }
  }

  getNoSelectionItem(): ThirdPartyEvaluationFormItem {
    const answerArray = this.evaluationFormGroup.get(this.evaluationFormControlName).value as Array<ThirdPartyEvaluationFormItem>;

    const noSelectionChild = answerArray.find(x => x.id == null);
    this.noSelectionItem = !!noSelectionChild;
    return noSelectionChild ? noSelectionChild : Object.assign(new ThirdPartyEvaluationFormItem(), { id: null, isTrue: true });
  }

  findItemAnswerId(answers: any[]) {
    if (this.itemType != EvaluationFormItemType.RecordAnswer) {
      var answerId =
        this.itemType != EvaluationFormItemType.Text ?
          this.evaluationFormGroup.get(this.evaluationFormControlName).value :
          this.answers[0].id;
      

      const itemAnswer = answers
        .find(a => (a.appFormItemAnswerId === answerId) || (a.followUpTaskFormItemAnswerId === answerId));
      return itemAnswer ? itemAnswer.id : 0;
    } else {
      const currentAppFormItemId = this.evaluationFormItem.id;
      const itemAnswer = answers
        .find(a => (a.appFormItemId === currentAppFormItemId) || (a.followUpTaskFormItemId === currentAppFormItemId));
      return itemAnswer ? itemAnswer.id : 0;
    }
  }

  fillUpConversation(answers: any[]) {
    // Validations
    if (!this.formConversations)
      return;
    if (this.conversationContextId) {
      this.itemAnswerId$ = this.conversationContextId;
    }
    else if (answers.length == 0 || !answers) {
      return;
    } else {
      // --
      const itemFormAnswer = this.evaluationFormGroup.get(this.evaluationFormControlName).value;

      // ---
      if (Array.isArray(itemFormAnswer) && itemFormAnswer.every(x => x) && itemFormAnswer[0]?.id != null) {
        const sorteditemFormAnswer = itemFormAnswer.sort((a: ThirdPartyEvaluationFormItem, b: ThirdPartyEvaluationFormItem) => a.id > b.id ? 1 : -1) as ThirdPartyEvaluationFormItem[];
        const unorderedAnswers = answers
          .filter(a => (a.appFormItemId == sorteditemFormAnswer[0].parentId) || (a.followUpTaskFormItemAnswerId == sorteditemFormAnswer[0].parentId));
        const orderedAnswers = unorderedAnswers.sort((a, b) => a.id > b.id ? 1 : -1);

        if (orderedAnswers[0]) {
          this.itemAnswerId$ = orderedAnswers[0].id;
        }
      } else {
        this.itemAnswerId$ = this.findItemAnswerId(answers);
      }
    }

    // ToDo: Por ahora siempre traigo de los item conversation... si hubiese un FormConversation habria
    // que retocar esto
    const conversationItems = (this.formConversations.itemsConversations as any[])
      .filter(x => !x.isFormComment && ((x.thirdPartyEvaluationFormAnswerId === this.itemAnswerId$) || (x.thirdPartyFollowUpTaskFormItemId === this.itemAnswerId$)));
    // console.log(conversationItems)
    this.conversation$.next(conversationItems);
  }

  private isEmptyOrWhiteSpace(value): boolean {
    return (String(value).replace(/\s/g, '') == '') || !value;
  }

  enqueueMessageItem(msgItem: ThirdPartyConversationItem) {
    this.message.emit(msgItem);
  }

  dequeueMessageItem(msgItem: ThirdPartyConversationItem) {
    this.messageDequeue.emit(msgItem);
  }

  enqueueFileItem(fileItem: ThirdPartyEvaluationFormAnswerFile) {
    // console.log(fileItem)
    // Evita que sin haber seleccionado ninguna opcion en una pregunta con hijos el appFormItemAnswerId esté en null
    if (this.evaluationFormItem.itemTypeId == EvaluationFormItemType.MultipleDropDownSelection) {
      fileItem.appFormItemAnswerId = fileItem.appFormItemAnswerId ?? this.evaluationFormItem.id;
    }
    if(fileItem.appFormItemAnswerId == 0){
      fileItem.appFormItemAnswerId = this._itemAnswerId$.getValue();
    }
    if(fileItem.appFormItemAnswerId == 0){
      fileItem.appFormItemAnswerId = this.findItemAnswerId(this.formAnswers);
    }
    
    // console.log(this.findItemAnswerId(this.formAnswers))
    // console.log(fileItem)
    this.fileUpload.emit(fileItem);
  }

  dequeueFileItem(fileItem: ThirdPartyEvaluationFormAnswerFile) {
    this.fileDequeue.emit(fileItem);
  }

  enableConversationFeature(): boolean {
    // console.log(this.showConversation)
    // console.log(this.conversation$.getValue().length > 0)
    const itemFormAnswer = this.evaluationFormGroup.get(this.evaluationFormControlName).value;
    // console.log(itemFormAnswer)
    return ((this.showConversation && this.conversation$.getValue().length > 0) || this.forceShowConversation) && ((itemFormAnswer != null && itemFormAnswer.length > 0 && itemFormAnswer[0] != null && itemFormAnswer[0].id != null) || Number.isInteger(itemFormAnswer));
  }

  enableFileUploadFeature(): boolean {
    const featureEnabled: boolean =
      (this.enableFileManager && this.itemFilesAvailable) ||
      this.itemType == EvaluationFormItemType.DueDiligenceFeatureItem;

    return featureEnabled;
  }

  canUploadFiles() {
    const userPermissions = (this.currentUser.permissions as Array<any>).map(x => x.id);
    // console.log(this.protectedMode)
    return !this.protectedMode ||
      (this.itemType == EvaluationFormItemType.DueDiligenceFeatureItem && !this.protectedMode);
  }

  removeMultipleSelectionNullValue(): void {
    const selectedValues = this.evaluationFormGroup.get(this.evaluationFormControlName).value as Array<any>;

    // Si hubiese más de un valor y uno de estos tiene id 'null', se remueve
    if (selectedValues.length > 1) {
      const cleanValues = selectedValues.filter(x => x.id);
      this.evaluationFormGroup.get(this.evaluationFormControlName).patchValue(cleanValues);
    }
  }

  nullSelectionEnabled(): boolean {
    const selectedValues = this.evaluationFormGroup.get(this.evaluationFormControlName).value as Array<any>;
    return selectedValues.every(x => !x) || selectedValues.some(x => !x.id);
  }

  dropItemInList(event: CdkDragDrop<string>, control: AbstractControl) {
    const array = control.value || [];
    moveItemInArray(array, event.previousIndex, event.currentIndex);
    control.setValue(array);
  }

  addItemInList(value: string, input: HTMLInputElement) {
    const control = this.evaluationFormGroup.get(this.evaluationFormControlName);

    // Check out for null or blank spaces
    if ((value || '').trim()) {
      console.log(control.value);
      control.setValue((control.value || []).concat(value.trim()));
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeItemInList(item: any, control: AbstractControl) {
    const array = control.value;
    const index = array.indexOf(item);
    if (index >= 0) {
      array.splice(index, 1);
      control.setValue(array);
    }
  }
}
